import { SegmentPageTemplate } from 'src/components/pages/segment/SegmentPageTemplate';

import { useSuperpollutantsConfig } from './SuperpollutantsConfig';

export const SuperpollutantsPage = () => {
  const { isBundleLoading, config } = useSuperpollutantsConfig();

  return (
    <SegmentPageTemplate config={config} isBundleLoading={isBundleLoading} breadcrumbTitle={config?.heroAsset?.title} />
  );
};
